import React, { useRef } from 'react';
import styles from '../../styles/components/spacer.module.scss';
import classnames from 'classnames';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';


export default function Spacer({ data }) {
    const wrapperRef = useRef(null);
    const onScreen = useIntersectionObserver(wrapperRef);

    return (
        <div
            className={classnames(
                styles.spacer,
                styles[data.style],
                onScreen?.isIntersecting ? styles.visible : ''
            )}
            id={data.anchorId}
            ref={wrapperRef}
        >
        </div>
    );
}